<template>
  <div class="knowledge">
    <!-- {{ searchData }}
    {{ knowledList }}
    {{ aa }}
    {{ query }} -->
    <!-- <div class="knowledge-top">
      <div class="on">按时间</div>
      <div>按章节</div>
    </div> -->
    <div class="knowledge-list-box">
      <div class="knowledge-list knowledge-list-title">
        <div>知识点</div>
        <template v-if="$route.name == 'StudentLearning'">
          <div>个人掌控率</div>
          <div>个人考频</div>
        </template>
        <template v-if="$route.name == 'ClassLearing'">
          <div>班级掌控率</div>
          <div>班级考频</div>
        </template>
        <template v-if="$route.name == 'GradeLearning'">
          <div>年级掌控率</div>
          <div>年级考频</div>
        </template>
      </div>
      <div
        v-for="(v, i) in knowledList"
        :key="i"
        class="knowledge-list"
        @click="goDetail(v.knowledgeId, v.knowledgeName)"
      >
        <div>{{ v.knowledgeName }}</div>
        <div>{{ v.scoreRateAvg | setNumber }}</div>
        <div>{{ v.frequency }}</div>
        <!-- <div v-else>{{ v.countFail }}</div> -->
      </div>
    </div>
    <div class="loading-box">
      <van-loading v-if="current < page" size="24px">加载中...</van-loading>
      <van-divider v-else dashed>没有找到更多了</van-divider>
    </div>
  </div>
</template>

<script>
import { knowledgePage } from "@/api/interface";
export default {
  name: "Knowledge",
  props: { searchData: Object },
  data() {
    return {
      current: 0,
      page: 2,
      knowledList: [],
    };
  },
  created() {
    // console.log(this.$route.name);
    this.current = 1;
    this.getKnowList();
  },
  mounted() {
    window.addEventListener("scroll", this.disposeScroll); //监听滚动条
  },
  beforeDestroy() {
    //离开
    window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
  },
  methods: {
    disposeScroll() {
      // if (this.page > this.totalpage) {
      //   return;
      // } // 如果当前大于总页数，也就是最后一页，那么就不不触发了
      // let top =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop ||
      //   0; // 获取滚动条垂直的位置
      // if (top + window.innerHeight >= document.body.clientHeight) {
      //   this.current++;
      //   this.getKnowList();
      //   // console.log("11111111");
      //   //如果滚动条的位置加上窗口的高度大于可见的窗口可见的高度，那么也就是滚动条到低了
      //   // this.$emit('update') // 执行update方法
      // }totalpage
      if (this.current == this.page) {
        return;
      } // 如果当前大于总页数，也就是最后一页，那么就不不触发了
      let top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0; // 获取滚动条垂直的位置
      if (document.body.clientHeight - top - window.innerHeight < 20) {
        this.current++;
        this.getKnowList();
        //如果滚动条的位置加上窗口的高度大于可见的窗口可见的高度，那么也就是滚动条到低了
        // this.$emit('update') // 执行update方法
      }
    },
    goDetail(id, knowledgeName) {
      let data = Object.assign(this.$route.query, this.searchData);
      data.knowledgeId = id;
      data.knowledgeName = knowledgeName;
      data.knowType = this.$route.name;
      data.urlType = data.knowType;
      delete data.schoolID;
      if (data.knowType == "GradeLearning") {
        delete data.classNum;
        delete data.studentID;
      }
      if (data.knowType == "ClassLearing") {
        delete data.studentID;
      }
      this.$router.push({
        name: "ShowKnowledge",
        query: data,
      });
    },
    getKnowList() {
      let data = JSON.parse(JSON.stringify(this.searchData));
      data.sortType = 3;
      data.sortOrder = 1;
      data.current = this.current;
      data.size = 14;
      knowledgePage(data).then((res) => {
        this.current = res.data.current;
        this.page = res.data.pages;
        if (this.current == 1) {
          this.aa = res.data;
          this.query = data;
          this.knowledList = res.data.records;
        } else {
          this.knowledList = this.knowledList.concat(res.data.records);
          // console.log(this.knowledList);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.knowledge {
  padding: 20px 12px;
  .loading-box {
    text-align: center;
  }
  .knowledge-top {
    padding: 20px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      padding: 6px 12px;
      border: 1px solid #7b9cc7;
    }
    .on {
      background-color: #7b9cc7;
      color: #ffffff;
    }
  }
  .knowledge-list-box {
    border: 1px solid #e0e0e0;
    .knowledge-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e0e0e0;
      &:last-child {
        border-bottom: none;
      }
      .err {
        color: #fc5743;
      }
      div {
        width: 33.33%;
        padding: 14px 8px;
        text-align: center;
        color: rgba(0, 0, 0, 0.85);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .knowledge-list-title {
      div {
        color: rgba(0, 0, 0, 0.5);
      }
    }
  }
}
</style>
